// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/icomoon/icomoon.eot?-i3y62n", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/icomoon/icomoon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/icomoon/icomoon.woff?-i3y62n", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/icomoon/icomoon.ttf?-i3y62n", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../font/icomoon/icomoon.svg?-i3y62n", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix-i3y62n" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^="icon-"], [class*=" icon-"] {
  font-family: 'icomoon';
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-list-numbered:before {
  content: "\\e9b9";
}

.icon-list2:before {
  content: "\\e9bb";
}

.icon-arrow-left:before {
  content: "\\ea40";
}

.icon-cancel-circle:before {
  content: "\\ea0d";
}

.icon-done-circle:before {
  content: "\\e900";
}

.icon-cross:before {
  content: "\\ea0f";
}

.icon-bold:before {
  content: "\\ea62";
}

.icon-italic:before {
  content: "\\ea64";
}

.icon-arrow-right2:before {
  content: "\\ea3c";
}

.icon-arrow-left2:before {
  content: "\\ea40";
}

.icon-checkmark:before {
  content: "\\e900";
}

`, "",{"version":3,"sources":["webpack://./src/css/icomoon.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,2CAA8C;EAC9C;;;yDAGkE;EAClE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:url('../font/icomoon/icomoon.eot?-i3y62n');\n  src:url('../font/icomoon/icomoon.eot?#iefix-i3y62n') format('embedded-opentype'),\n    url('../font/icomoon/icomoon.woff?-i3y62n') format('woff'),\n    url('../font/icomoon/icomoon.ttf?-i3y62n') format('truetype'),\n    url('../font/icomoon/icomoon.svg?-i3y62n#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  font-family: 'icomoon';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-list-numbered:before {\n  content: \"\\e9b9\";\n}\n\n.icon-list2:before {\n  content: \"\\e9bb\";\n}\n\n.icon-arrow-left:before {\n  content: \"\\ea40\";\n}\n\n.icon-cancel-circle:before {\n  content: \"\\ea0d\";\n}\n\n.icon-done-circle:before {\n  content: \"\\e900\";\n}\n\n.icon-cross:before {\n  content: \"\\ea0f\";\n}\n\n.icon-bold:before {\n  content: \"\\ea62\";\n}\n\n.icon-italic:before {\n  content: \"\\ea64\";\n}\n\n.icon-arrow-right2:before {\n  content: \"\\ea3c\";\n}\n\n.icon-arrow-left2:before {\n  content: \"\\ea40\";\n}\n\n.icon-checkmark:before {\n  content: \"\\e900\";\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
